export default "__VITE_ASSET__BLTeyiPg__"